export default "__VITE_ASSET__CkqsLuJu__"